import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { screenResize } from 'Store/Screen/actions';
import user, { IUser } from 'Store/User/reducer';
import order, { IOrder } from 'Store/Order/reducer';
import screen, { IScreen } from 'Store/Screen/reducer';
import banners, { IBanners } from 'Store/Banners/reducer';
import event, { IEvent } from 'Pages/EventDetailPage/Redux/reducer';
import events, { IEvents } from 'Pages/EventsPage/Redux/reducer';
import orderItem, { IOrderItem } from 'Components/OrderItem/Redux/reducer';
import ticket, { ITicket } from 'Pages/TicketPage/Redux/reducer';
import manualSeatPicker, { IManualSeatPicker } from 'Components/PickSeatManually/Redux/reducer';
import infoVoucher, { IInfoVoucher } from 'Pages/InfoVoucherPage/Redux/reducer';
import infoContact, { IInfoContact } from 'Components/InfoContact/Redux/reducer';
import infoFaq, { IInfoFaq } from 'Components/InfoFaq/Redux/reducer';
import infoAgents, { IInfoAgents } from 'Components/InfoAgents/Redux/reducer';
import infoAbout, { IInfoAbout } from 'Components/InfoAbout/Redux/reducer';
import infoJobs, { IInfoJobs } from 'Components/InfoJobs/Redux/reducer';
import infoGroupBooking, { IInfoGroupBooking } from 'Pages/InfoGroupBookingPage/Redux/reducer';
import infoCustomerService, { IInfoCustomerService } from 'Components/InfoCustomerService/Redux/reducer';
import infoOrganizer, { IInfoOrganizer } from 'Pages/InfoOrganizerPage/Redux/reducer';
import infoTerms, { IInfoTerms } from 'Pages/InfoTermsPage/Redux/reducer';
import infoCookies, { IInfoCookies } from 'Components/CookiesPopup/Redux/reducer';
import skanetrafiken, { ISkanetrafiken } from 'Components/PickSkanetrafiken/Redux/reducer';

import { 
  applyMiddleware, 
  combineReducers, 
  createStore, 
  Store,
} from 'redux';

declare module 'redux' {
  export type GenericStoreEnhancer = StoreEnhancer;
}

export interface IStore {
  user: IUser;
  order: IOrder;
  screen: IScreen;
  banners: IBanners;
  events: IEvents;
  event: IEvent;
  orderItem: IOrderItem;
  ticket: ITicket;
  manualSeatPicker: IManualSeatPicker;
  infoVoucher: IInfoVoucher;
  infoContact: IInfoContact;
  infoFaq: IInfoFaq;
  infoAgents: IInfoAgents;
  infoAbout: IInfoAbout;
  infoJobs: IInfoJobs;
  infoGroupBooking: IInfoGroupBooking;
  infoOrganizer: IInfoOrganizer;
  infoCustomerService: IInfoCustomerService;
  infoTerms: IInfoTerms;
  infoCookies: IInfoCookies;
  skanetrafiken: ISkanetrafiken;
}

export const reducers = combineReducers<IStore>({
  user,
  order,
  screen,
  banners,
  events,
  event,
  orderItem,
  ticket,
  manualSeatPicker,
  infoVoucher,
  infoContact,
  infoFaq,
  infoAgents,
  infoAbout,
  infoJobs,
  infoGroupBooking,
  infoOrganizer,
  infoCustomerService,
  infoTerms,
  infoCookies,
  skanetrafiken,
});

const reduxStore: Store<IStore> = createStore(
  reducers,
  composeWithDevTools(
    applyMiddleware(thunk),
  ),
);

window.addEventListener('resize', () => {
  reduxStore.dispatch(screenResize(window.innerWidth));
});

export default reduxStore;


// WEBPACK FOOTER //
// ./src/store/index.tsx